export interface MySubmissionSummary {
  id: string;
  submissionDate: string;
  submittedAt: string;
  submittedBy?: { userId: string; userDetails: string };
  data: Record<string, unknown>;
  progress?: Record<string, { done: boolean }>;
}

export interface MySubmission extends MySubmissionSummary {
  editedAt?: string;
  editedBy?: { userId: string; userDetails: string };
}

/** Submissions the current signed-in user has created (never other users' data). */
export async function listMySubmissions(): Promise<MySubmissionSummary[]> {
  const r = await fetch("/api/submissions/mine");
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function getMySubmission(id: string): Promise<MySubmission> {
  const r = await fetch(`/api/submissions/mine/${id}`);
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}
